export const companyOverviewSelector = state => state.companyOverview;
